import { Component, Input, inject } from "@angular/core";
import {
  FacilityMonitoringClientProvider,
  MonitoringFacilityStatus,
  MonitoringStatusDto,
} from "src/app/web-api/web-api";

@Component({
    selector: "app-anlage-api-monitoring-status-led",
    templateUrl: "./status-led.component.html",
    styleUrls: ["./status-led.component.scss"],
    standalone: false
})
export class AnlageApiMonitoringStatusLedComponent {
  private _client = inject(FacilityMonitoringClientProvider);

  @Input() status: MonitoringStatusDto;

  getClassList() {
    const result = ["led"];
    switch (this.status.facilityStatus) {
      case MonitoringFacilityStatus.ReadyForOperation:
        result.push("led-green");
        break;
      case MonitoringFacilityStatus.Maintenance:
        result.push("led-yellow");
        break;
      case MonitoringFacilityStatus.Malfunction:
        result.push("led-red");
        break;
      default:
        result.push("led-gray");
        break;
    }
    if (this.status.emergencyCallTriggered) {
      result.push("led-exclamation");
    }
    return result.join(" ");
  }

  _canStateReset() {
    return this.status && this.status.facilityStatus != MonitoringFacilityStatus.ReadyForOperation;
  }
  _onStateReset() {
    if (!this._canStateReset()){
      return;
    }
    this._client
      .statusResetSingle(this.status.blackboxID)
      .subscribe((result) => {
        this.status.description = result.description;
        this.status.emergencyCallTriggered = result.emergencyCallTriggered;
        this.status.facilityStatus = result.facilityStatus;
        this.status.facilityStatusDisplayText = result.facilityStatusDisplayText;
      });
  }
}
